import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a186f10")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpen = $event)),
    style: {"max-width":"unset!important"},
    contentClass: "modal-limit modal-limit-pelecard",
    modalWidth: _ctx.maxWidth
  }, {
    default: _withId(() => [
      (_ctx.frameUrl)
        ? (_openBlock(), _createBlock("iframe", {
            key: 0,
            class: "frame",
            src: _ctx.frameUrl,
            frameborder: "0"
          }, null, 8, ["src"]))
        : _createCommentVNode("", true),
      _createVNode("div", null, [
        _createVNode("button", {
          class: "close-button-wrapper popup-bookit-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close())),
          type: "button"
        }, _toDisplayString(_ctx.$t('button.close')), 1)
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "modalWidth"]))
})